import React, { type PropsWithChildren } from 'react';

import invariant from 'tiny-invariant';

import { fg } from '@atlaskit/platform-feature-flags';

import { useOptions } from '../../controllers/options-provider';
import { useNetworkSideNavUserData } from '../../controllers/user-state/persistence/use-network-side-nav-user-data';
import { StoreProviders } from '../../controllers/user-state/store-providers';

export function NetworkStore({ children }: PropsWithChildren) {
	const { networkStorageParams, app } = useOptions();

	if (fg('navx-1766-new-network-storage-params')) {
		invariant(
			networkStorageParams?.activationId &&
				networkStorageParams?.ownerAri &&
				networkStorageParams?.queryRef &&
				networkStorageParams?.siteId,
			'Please provide networkStorageParams when using customization',
		);
	} else {
		invariant(
			networkStorageParams?.entityAri &&
				networkStorageParams?.ownerAri &&
				networkStorageParams?.queryRef,
			'Please provide networkStorageParams when using customization',
		);
	}

	// This is user data for the menu and the sidebar
	const userStoreProps = useNetworkSideNavUserData({ ...networkStorageParams, firstPartyApp: app });

	return <StoreProviders {...userStoreProps}>{children}</StoreProviders>;
}
